module.exports = __webpack_public_path__ + "media/images/index/24hours-4d28476b1200df7eafbafeaa86010c24.svg";